import {BruteForce} from "../BruteForce";
import {BruteForceGameMode} from "../server/BruteForceGameMode";
import {BelowStakeWinRestriction} from "../server/BelowStakeWinRestriction";
import {BruteForceGameData} from "../server/BruteForceData";
import {SimpleReelModel, SimpleReelModelSymbolData} from "../../core/reel/simplereel/SimpleReelModel";
import {BruteForceSymbol, BruteForceSymbolStates} from "../reels/BruteForceSymbol";
import {BruteForceXNudgeSymbol} from "../reels/BruteForceXNudgeSymbol";

export class RestoreUtils {

    constructor() {

    }

    public static startupGame() {
        if (BruteForce.model.initData.isRestoreState) {
            if (BruteForce.model.data.nextMode !== BruteForceGameMode.NORMAL) {
                if (BruteForce.model.initData.freespinsTriggeredThisSpin) {
                    RestoreUtils.restoreFreespinWithIntro()
                } else {
                    RestoreUtils.restoreFreespin();
                }
            }
        }

        RestoreUtils.handleXBet();
    }


    public static restoreFreespinWithIntro() {
        BruteForce.keypadPlugin.setWin(BruteForce.model.data.accumulatedRoundWin, true, BelowStakeWinRestriction.isWinBelowStake());
    }


    public static restoreFreespin() {
        if (BruteForce.model.mode === "FREESPIN_SUPER") { // to fix sticky xNudgeState in SFS
            BruteForce.allreelsView.reelModels.forEach((reelModel: SimpleReelModel, reelIndex: number) => {
                const currentReelSet: SimpleReelModelSymbolData[] = reelModel.getAllVisibleStopSymbols();

                for (let i: number = 0; i < currentReelSet.length - 1; i++) {
                    if ((<BruteForceSymbol>currentReelSet[i].positionable).symbolName.includes("XN")) {

                        reelModel.stepsToNudge = 0;
                        if (BruteForce.model.initData.xNudgeSticky[reelIndex]) {
                            (<BruteForceXNudgeSymbol>currentReelSet[i].positionable).setState(BruteForceSymbolStates.HAPPY);
                            (<BruteForceXNudgeSymbol>currentReelSet[i].positionable).addLockAnimation().timeScale(100);
                            (<BruteForceXNudgeSymbol>currentReelSet[i].positionable).setMeter(BruteForce.model.initData.xNudgeMultipliers[reelIndex]);
                            reelModel.reelView.isReelContainingFullNudge = true;
                        } else {
                            (<BruteForceXNudgeSymbol>currentReelSet[i].positionable).setState(BruteForceSymbolStates.SAD);
                        }
                        break;
                    }
                }

            });
            let stickyNudgeValue: number = 0;
            BruteForce.model.xNudgeSticky.forEach((item: boolean, index: number) => {
                if (item) {
                 //   if (NudgeMeterMultiplierRetentionCases.retainForXNOnReel(index)) {
                        stickyNudgeValue += BruteForce.model.xNudgeMultipliers[index];
                   // }
                }
            });
            BruteForce.gameContainer.showMultiplier(stickyNudgeValue === 0 ? "" : stickyNudgeValue.toString() + "x");
        }
        BruteForce.keypadPlugin.setWin(BruteForce.model.data.accumulatedRoundWin, true, BelowStakeWinRestriction.isWinBelowStake());
    }


    private static handleXBet() {
        if (BruteForce.apiPlugin.isReplay || BruteForce.model.isRestore) {
            BruteForce.apiPlugin.betFeatureController.setActiveBetFeature();
        }
    }
}